import an_untamed_state from './img/an_untamed_state.jpg'
import big_little_lies from './img/big_little_lies.jpg'
import fingersmith from './img/fingersmith.jpg'
import gone_girl from './img/gone_girl.jpg'
import home_before_dark from './img/home_before_dark.jpg'
import i_am_watching_you from './img/i_am_watching_you.jpg'
import lock_every_door from './img/lock_every_door.jpg'
import my_last_lie from './img/my_last_lie.jpg'
import my_lovely_wife from './img/my_lovely_wife.jpg'
import sharp_objects from './img/sharp_objects.jpg'
import silent_patient from './img/silent_patient.jpg'
import stillhouse_lake from './img/stillhouse_lake.jpg'
import the_Da_vinci_code from './img/the_Da_vinci_code.jpg'
import the_girl_on_the_train from './img/the_girl_on_the_train.jpg'
import the_guest_list from './img/the_guest_list.jpg'
import the_other_black_girl from './img/the_other_black_girl.jpg'
import the_shining from './img/the_shining.jpg'
import the_silence_of_the_lambs from './img/the_silence_of_the_lambs.jpg'
import the_wife_between_us from './img/the_wife_between_us.jpg'
import the_woman_in_the_window from './img/the_woman_in_the_window.png'
import then_she_was_gone from './img/then_she_was_gone.jpg'
import verity from './img/verity.jpg'
import you from './img/you.jpg'
import you_will_know_me from './img/you_will_know_me.jpg'


export const SBookItems = [
  {
    id:601,
    title:"An Untamed State",
    image: an_untamed_state,
    price:1999,
    
  },
  {
    id:602,
    title:"Big Little Lies",
    image: big_little_lies,
    price:2899,
    
  },
  {
    id:603,
    title:"Fingersmith",
    image: fingersmith,
    price:17999,
    
  },
  {
    id:604,
    title:"Gone Girl",
    image: gone_girl,
    price:2999,
    
  },
  {
    id:605,
    title:"Home Before Dark",
    image: home_before_dark,
    price:799,
    
  },
  {
    id:606,
    title:"I Am Watching You",
    image: i_am_watching_you,
    price:1199,
    
  },
  {
    id:607,
    title:"Lock Every Door",
    image: lock_every_door,
    price:999,
    
  },
  {
    id:608,
    title:"My Last Lie",
    image: my_last_lie,
    price:399,
    
  },
  {
    id:609,
    title:"My Lovely Wife",
    image: my_lovely_wife,
    price:4999,
    
  },
  {
    id:610,
    title:"Sharp Objects",
    image: sharp_objects,
    price:1599,
    
  },
  {
    id:611,
    title:"The Silent Patient",
    image: silent_patient,
    price:2499,
    
  },
  {
    id:612,
    title:"Stillhouse Lake",
    image: stillhouse_lake,
    price:799,
    
  },
  {
    id:613,
    price:1379,
    title: "The Da Vinci Code",
    image: the_Da_vinci_code,
    
  },
  {
    id:614,
    price:2199,
    title: "The Girl On The Train",
    image: the_girl_on_the_train,
   
  },
  {id:615,
    price:2199,
    title: "The Guest List",
    image: the_guest_list,
    
  },
  {
    id:616,
    price:899,
    title: "The Other Black Girl",
    image: the_other_black_girl,
    
  },
  {
    id:617,
    price:2499,
    title: "The Shining",
    image: the_shining,
    
  },
  {
    id:618,
    price:699,
    title: "The Silence Of The Lambs",
    image: the_silence_of_the_lambs,
    
  },
  {
    id:619,
    price:2049,
    title: "The Wife Between Us",
    image: the_wife_between_us,
    
  },
  {
    id:620,
    price:1449,
    title: "The Woman in the Window",
    image: the_woman_in_the_window,
    
  },
  {
    id:621,
    price:4349,
    title: "Then She Was Gone",
    image: then_she_was_gone,
    
  },
  {
    id:622,
    price:299,
    title: "Verity",
    image:verity,    
  },
  {
    id:623,
    price:399,
    title: "You",
    image: you,
    
  },
  {
    id:624,
    price:2669,
    title: "You Will Know Me",
    image: you_will_know_me,
    
  },
  
];